import {useState} from "react";
import {useTranslation} from "react-i18next";
import {Box, Button, TextField, Typography} from "@mui/material";

import {createCourse} from "../api/api";
import CourseLogoSelect from "./CourseLogoSelect";

interface Props {
    onClose: () => void;
    onSuccess: () => void;
    onError: (error: string) => void;
}

const CourseForm = ({onSuccess, onError}: Props) => {
    const {t} = useTranslation();

    const [title, setTitle] = useState("");
    const [description, setDescription] = useState("");
    const [logoId, setLogoId] = useState<number | null>(null);
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        setLoading(true);

        try {
            await createCourse({
                title,
                description,
                logoId,
            });

            onSuccess();
        } catch (error: any) {
            onError(
                error.response?.data?.message ||
                t("courseslist.errors.addFailed")
            );
        } finally {
            setLoading(false);
        }
    };

    return (
        <Box sx={{display: "flex", flexDirection: "column", gap: 2}}>
            <Typography variant="h6" sx={{mb: 2}}>
                {t("courseslist.addCourse")}
            </Typography>

            <form onSubmit={handleSubmit}>
                <TextField
                    label={t("courseslist.courseTitle")}
                    fullWidth
                    required
                    value={title}
                    onChange={(e) => setTitle(e.target.value)}
                    disabled={loading}
                    sx={{mb: 2}}
                />

                <TextField
                    label={t("courseslist.courseDescription")}
                    fullWidth
                    required
                    multiline
                    rows={3}
                    value={description}
                    onChange={(e) => setDescription(e.target.value)}
                    disabled={loading}
                    sx={{mb: 2}}
                />

                <Box sx={{mb: 2}}>
                    <CourseLogoSelect
                        value={logoId}
                        onChange={setLogoId}
                        disabled={loading}
                        onError={onError}
                    />
                </Box>

                <Button
                    type="submit"
                    variant="contained"
                    disabled={loading}
                    fullWidth
                >
                    {t("common.create")}
                </Button>
            </form>
        </Box>
    );
};

export default CourseForm;